<script lang="ts">
    import Nav from '$lib/components/Nav.svelte';
    import Hero from '$lib/components/Hero.svelte';
    import Contact from '$lib/components/Contact.svelte';
    import Footer from '$lib/components/Footer.svelte';
</script>

<Nav />
<Hero />
<Contact />
<Footer />
